import { render, staticRenderFns } from "./RemoveProductModal.vue?vue&type=template&id=a475a976&"
import script from "./RemoveProductModal.vue?vue&type=script&lang=js&"
export * from "./RemoveProductModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveProductModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports